<template>
  <main class="px-0 md:px-4 py-4">
    <div
      class="flex flex-row-reverse items-center justify-between sm:flex-col sm:items-start mb-6 sm:mb-0"
    >
      <h4
        class="md:mt-3 md:text-sm md:text-left text-xs font-medium text-dark-600 sm:text-headerText capitalize sm:uppercase"
      >
        Employee / Add Employee
      </h4>
      <div class="text-left sm:mt-4 sm:mb-6">
        <easiBackButton></easiBackButton>
      </div>
    </div>

    <div
      class="flex items-center w-full md:w-1/2 mx-auto border border-outlineGray rounded-xl tracking-wide justify-center md:mt-8 md:mb-12 mt-4 mb-6 gap-x-2 p-2 text-sm font-medium cursor-pointer bg-white"
    >
      <span
        @click="toggleAdd"
        :class="
          singleAdd
            ? 'bg-primary shadow-2xl text-white '
            : 'bg-newGrey md:shadow-none shadow-2xl'
        "
        class="w-full text-sm text-center rounded-lg md:px-5 md:py-2 px-3 py-2"
        >Single Add</span
      >
      <span
        @click="toggleAdd"
        :class="
          !singleAdd
            ? 'bg-primary shadow-2xl text-white'
            : 'bg-newGrey md:shadow-none shadow-2xl'
        "
        class="w-full text-sm text-center rounded-lg md:px-5 md:py-2 px-3 py-2"
        >Bulk Add</span
      >
    </div>
    <div v-show="singleAdd" class="flex w-full items-center justify-center">
      <div
        @click="empDetails = true"
        :class="
          empDetails
            ? 'bg-primary bg-secondary text-white '
            : 'border border-gray'
        "
        class="cursor-pointer rounded-full w-6 h-6 text-center flex items-center font-bold justify-center text-xs"
      >
        1
      </div>
      <hr class="w-24 my-1 border-2 text-dividerColor" />

      <div
        @click="toggleToSalaryScreen"
        :class="
          !empDetails
            ? 'bg-primary bg-secondary text-white '
            : 'border border-gray'
        "
        class="cursor-pointer rounded-full w-6 h-6 text-center flex items-center font-bold justify-center text-xs"
      >
        2
      </div>
    </div>

    <div
      v-show="empDetails && singleAdd"
      class="md:w-1/2 w-full py-10 mx-auto bg-white rounded-2xl mt-10 mb-12 relative text-left border border-boxBorder md:shadow-lg"
    >
      <div class="flex flex-col items-center gap-2 mb-2 text-center">
        <h2 class="text-center text-headerText font-bold text-lg md:text-2xl">
          Enter Basic Employee Details
        </h2>

        <span
          v-if="salaryArgsFromStore.length && addedEmps.length > 0"
          class="text-sm text-left text-primary font-bold"
        >
          {{ addedEmps.length }} employee(s) added successfully
        </span>
      </div>
      <hr class="my-4 border-0.5 border-dividerColor text-dividerColor" />

      <p class="text-xs text-error text-center">
        Please fill mandatory fields (*)
      </p>

      <form
        @submit.prevent="submit"
        autocomplete="on"
        class="flex flex-col mt-5 px-3 md:px-12 lg:px-8 xl:px-10"
      >
        <div class="mb-1">
          <label for="employmentType" class="text-dark-600 text-sm font-medium"
            >Title</label
          >

          <easiSelectInput2
            required
            class="mt-0 mb-0"
            @update="args.title = $event"
            :value="args.title"
            :options="[
              {
                label: 'Mr',
                value: 'Mr',
              },
              {
                label: 'Mrs',
                value: 'Mrs',
              },
              {
                label: 'Miss',
                value: 'Miss',
              },
            ]"
          />
        </div>
        <!-- <label for="firstName" class="text-dark-600 text-sm font-medium"
          >First Name
          <span class="text-xs text-error tracking-wide"> *</span></label
        > -->
        <TextInput
          placeholder="First Name"
          v-model="args.firstName"
          type="text"
          name="firstName"
          class="mt-1 mb-5"
          required
        />

        <!-- <label for="lastName" class="text-dark-600 text-sm font-medium"
          >Last Name
          <span class="text-xs text-error tracking-wide"> *</span></label
        > -->
        <TextInput
          placeholder="Last Name"
          v-model="args.lastName"
          type="text"
          name="lastName"
          class="mt-1 mb-5"
          required
        />

        <div class="mt-4 mb-1">
          <label
            for="employmentType"
            class="mt-2 text-dark-600 text-sm font-medium"
            >Gender</label
          >

          <easiSelectInput2
            required
            class="mt-1 mb-0"
            @update="args.gender = $event"
            :value="args.gender"
            :options="[
              {
                label: 'Male',
                value: 'MALE',
              },
              {
                label: 'Female',
                value: 'FEMALE',
              },
              {
                label: 'Other',
                value: 'OTHER',
              },
            ]"
          />
        </div>
        <!-- <label for="email" class="text-dark-600 text-sm font-medium"
          >Email Address
          <span class="text-xs text-error tracking-wide"> *</span></label
        > -->
        <TextInput
          placeholder="Email (Optional)"
          v-model="args.email"
          type="email"
          name="email"
          class="mt-1 mb-5"
          :error="errorRules.email"
          autocom
        />

        <!-- <label for="phoneNumber" class="text-dark-600 text-sm font-medium"
          >Phone Number
          <span class="text-xs text-gray tracking-wide">
            (Recommended)</span
          ></label
        > -->
        <TextInput
          placeholder="Phone Number (Recommended)"
          v-model="args.phoneNumber"
          type="number"
          name="phoneNumber"
          class="mt-1 mb-5"
          :error="errorRules.userInput"
        />

        <!-- <label for="jobTitle" class="text-dark-600 text-sm font-medium"
          >Job Title</label
        > -->
        <TextInput
          placeholder="Job Title"
          v-model="args.jobTitle"
          type="text"
          name="jobTitle"
          class="mt-1 mb-5"
        />

        <div class="mt-4 mb-1">
          <label
            for="employmentType"
            class="mt-2 text-dark-600 text-sm font-medium"
            >Employment Type</label
          >

          <easiSelectInput2
            required
            class="mt-0 mb-0"
            @update="args.employmentType = $event"
            :value="args.employmentType"
            :options="[
              {
                label: 'Fulltime',
                value: 'FULLTIME',
              },
              {
                label: 'Contract',
                value: 'CONTRACT',
              },
              {
                label: 'Part Time',
                value: 'PARTTIME',
              },
              {
                label: 'Volunteer',
                value: 'VOLUNTEER',
              },

              {
                label: 'NYSC',
                value: 'NYSC',
              },
              {
                label: 'Internship',
                value: 'INTERNSHIP',
              },

              {
                label: 'Apprentice',
                value: 'APPRENTICE',
              },
            ]"
          />
        </div>

        <div class="mt-4 mb-1">
          <label class="text-dark-600 text-sm font-medium"
            >Select Department</label
          >
          <easiSelectInput2
            required
            class="mt-1 mb-0"
            @update="args.departmentId = $event"
            :value="args.departmentId"
            :options="departmentOptions"
            :addOpt="true"
            :addOptText="'Add Department'"
            @addNew="addDept = true"
          />
        </div>

        <!-- <label for="employeeId" class="text-dark-600 text-sm font-medium"
          >Employee ID</label
        > -->
        <TextInput
          placeholder="Employee ID"
          type="text"
          name="employeeId"
          v-model="args.userName"
          class="mt-3 mb-5"
        />

        <button
          class="focus:outline-none text-sm mt-5 py-3 px-4 md:mx-auto justify-center bg-primary rounded-full text-white w-full"
        >
          Save And Continue
        </button>
      </form>
    </div>

    <div
      v-show="empDetails === false && singleAdd === true"
      class="md:w-1/2 w-full py-10 mx-auto bg-white rounded-2xl mt-10 mb-12 relative text-left border border-boxBorder shadow-lg"
    >
      <div class="mb-8">
        <h2
          class="text-center text-headerText font-bold md:text-xl text-lg md:text-2xl"
        >
          Benefits
        </h2>
        <hr class="my-4 text-dividerColor" />
        <div
          v-if="salaryArgsFromStore.length && addedEmps.length > 0"
          class="justify-center items-center gap-x-2 flex"
        >
          <input
            class=""
            v-model="sameAsPrevious"
            @change="usePrevious"
            type="checkbox"
            name=""
            id=""
          />
          <span class="text-xs text-dark-600">Same as previous</span>
        </div>
      </div>
      <form
        class="flex flex-col"
        @submit.prevent="allowanceComplete(true)"
        autocomplete="on"
      >
        <div class="flex flex-col px-3 md:px-12 lg:px-8 xl:px-10">
          <!-- <label for="grossPay" class="text-dark-600 text-sm font-medium"
            >Gross Pay</label
          > -->
          <TextInput
            placeholder="Gross Pay"
            v-model="args.staffLevel.grossAmount"
            :format="true"
            step="any"
            type="text"
            name="grossPay"
            class="mt-1 mb-5"
            required
          />
        </div>
        <hr class="mb-4 mt-2 text-dividerColor" />

        <div class="flex flex-col items-center gap-4">
          <h3 class="font-bold text-dark-600">Please Select Allowance Type</h3>

          <form class="flex gap-4" action="">
            <div>
              <label class="text-dark-600 font-normal text-sm mr-2" for="amount"
                >Amount</label
              >
              <input
                type="radio"
                name="percentage"
                id="percentage"
                :value="false"
                v-model="args.staffLevel.usePercentageForAllowance"
              />
            </div>

            <div>
              <label
                class="text-dark-600 font-normal text-sm mx-2"
                for="percentage"
                >Percentage of Total Salary</label
              >
              <input
                type="radio"
                name="percentage"
                id="percentage"
                :value="true"
                checked
                v-model="args.staffLevel.usePercentageForAllowance"
              />
            </div>
          </form>
        </div>
        <h4
          v-show="args.staffLevel.usePercentageForAllowance === false"
          class="text-dark-600 my-5 font-normal text-center"
        >
          Sum of all allowances must be equal to gross pay.
        </h4>
        <h4
          v-show="args.staffLevel.usePercentageForAllowance"
          class="text-dark-600 my-5 font-normal text-center"
        >
          Sum of all allowance must be equal to 100%
        </h4>

        <div
          class="grid grid-cols-2 lg:grid-cols-2 gap-x-4 gap-y-4 items-center px-3 md:px-12 lg:px-8 xl:px-10 mt-4"
        >
          <!-- <div
            v-for="allowance in allAllowanceData.data"
            :key="allowance._id"
            :class="
              allowanceToHide.includes(allowance._id) ? 'hidden' : 'col-span-1'
            "
          > -->
          <div
            v-for="allowance in allAllowanceData.data"
            :key="allowance._id"
            class="col-span-1"
          >
            <!-- <div class="flex w-full items-center justify-between">
              <label
                v-if="!allowanceToHide.includes(allowance._id)"
                :for="allowance.name"
                class="capitalize text-dark-600 text-sm font-medium"
              >
                {{ allowance.name }}
              </label>
              <span
                v-if="
                  !allowanceToHide.includes(allowance._id) &&
                  !staticAllowances.includes(allowance.name)
                "
              >
                <i
                  @click="hideAllowance(allowance._id)"
                  class="hidden md:block absolute mt-7 fas fa-minus-circle text-secondary mr-24 md:mr-12 -mr-24 cursor-pointer"
                ></i>
              </span>
            </div> -->
            <div class="relative">
              <easiTextInput
                :placeholder="capitalizeFirstLetter(allowance.name)"
                v-model="allowanceData[allowance._id]"
                :type="
                  args.staffLevel.usePercentageForAllowance ? 'text' : 'text'
                "
                :format="
                  args.staffLevel.usePercentageForAllowance ? false : true
                "
                step="any"
                :name="String(allowance._id)"
                class="mt-1 mb-2 relative"
              >
              </easiTextInput>
              <!-- <i
                v-if="
                  !allowanceToHide.includes(allowance._id) &&
                  !staticAllowances.includes(allowance.name)
                "
                @click="hideAllowance(allowance._id)"
                class="absolute top-0 right-0 fas fa-minus-circle text-secondary mt-10 mr-4 cursor-pointer"
              ></i> -->
            </div>

            <p
              v-show="
                args.staffLevel.usePercentageForAllowance === true &&
                Number(allowanceData[allowance._id]) > 100
              "
              class="text-error text-xs capitalize"
            >
              percentage value can't be more than 100
              <!-- {{ Number(allowanceData[allowance._id]) }} -->
            </p>
          </div>
        </div>
        <div
          class="col-span-2 justify-center mt-4 cursor-pointer px-3 md:px-12 lg:px-8 xl:px-10"
        >
          <span
            @click="addAllowance = true"
            class="text-secondary font-bold text-sm"
            ><i class="fas fa-plus mr-2"></i> Add Allowance</span
          >
        </div>

        <hr class="my-6 text-dividerColor" />

        <div class="hidden flex flex-col px-3 md:px-12 lg:px-8 xl:px-10">
          <label class="text-dark-600 text-sm font-medium">Select Bonus</label>
          <easiMultiSelectInput
            required
            class="mt-1 mb-3"
            @update="args.bonusIds = $event"
            :value="args.bonusIds"
            :options="bonusOptions"
          />

          <label class="text-dark-600 text-sm font-medium"
            >Select Deduction</label
          >
          <easiMultiSelectInput
            required
            class="mt-1 mb-1"
            @update="args.deductionIds = $event"
            :value="args.deductionIds"
            :options="deductionOptions"
          />
        </div>

        <!-- <hr class="my-6 text-dividerColor" /> -->

        <div class="flex flex-col px-3 md:px-12 lg:px-8 xl:px-10">
          <label for="deduction" class="text-dark-600 text-sm font-medium"
            >Select Statutory Deduction</label
          >
          <easiDeduction
            @update="checkUpdate($event)"
            :clear="clearObj"
            :value="tempBen"
            :usePercent="args.staffLevel.usePercentageForAllowance"
            :options="benefitsOptions"
            :grossAmount="args.staffLevel.grossAmount"
            :validate="validate"
          ></easiDeduction>
        </div>
        <hr class="mt-2 mb-4 text-dividerColor" />
        <div
          class="w-full grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-3 md:gap-y-5 px-3 md:px-12 lg:px-8 xl:px-10"
        >
          <div class="w-full md:col-span-1 col-span-2">
            <label for="banks" class="text-dark-600 text-sm font-medium"
              >Select Bank
            </label>
            <easiBankSelectInput @update="bankName = $event" :value="bankName">
            </easiBankSelectInput>
          </div>
          <div class="w-full md:mt-1 md:col-span-1 col-span-2">
            <!-- <label
              for="employeeId"
              class="invisible text-dark-600 text-sm font-medium"
              >Account Number</label
            > -->
            <TextInput
              placeholder="Account Number"
              required
              v-model="args.accountNumber"
              minlength="10"
              maxlength="10"
              type="text"
              name="employeeId"
              class="mt-1 mb-2"
            />
          </div>

          <div class="w-full col-span-2">
            <!-- <label for="employeeId" class="text-dark-600 text-sm font-medium"
              >Account Name</label
            > -->
            <TextInput
              placeholder="Account Name"
              required
              v-model="args.accountName"
              readonly
              type="text"
              name="employeeId"
              class="mt-1 mb-2"
            />

            <span
              v-if="accountWarning.length > 0 && args.accountName.length > 0"
              class="text-error font-medium text-xs capitalize"
              >{{ accountWarning }}</span
            >
          </div>
        </div>
        <div
          @click="prorate = true"
          class="cursor-pointer mb-2 mt-4 justify-center items-center gap-2 flex"
        >
          <img :src="prorateIcon" alt="" />
          <span class="text-sm font-medium text-secondary">Prorate Salary</span>
        </div>
        <div
          v-show="prorated"
          class="border border-boxBorder py-4 px-5 rounded-lg mx-auto"
        >
          <div class="float-right -mt-3 -mr-2">
            <svg
              @click="clearProrate"
              width="14"
              height="22"
              viewBox="0 0 22 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.7098 7.29008C14.6169 7.19635 14.5063 7.12196 14.3844 7.07119C14.2626 7.02042 14.1318 6.99428 13.9998 6.99428C13.8678 6.99428 13.7371 7.02042 13.6153 7.07119C13.4934 7.12196 13.3828 7.19635 13.2898 7.29008L10.9998 9.59008L8.70984 7.29008C8.52153 7.10178 8.26614 6.99599 7.99984 6.99599C7.73353 6.99599 7.47814 7.10178 7.28983 7.29008C7.10153 7.47838 6.99574 7.73378 6.99574 8.00008C6.99574 8.26638 7.10153 8.52178 7.28983 8.71008L9.58984 11.0001L7.28983 13.2901C7.19611 13.383 7.12171 13.4936 7.07094 13.6155C7.02017 13.7374 6.99404 13.8681 6.99404 14.0001C6.99404 14.1321 7.02017 14.2628 7.07094 14.3847C7.12171 14.5065 7.19611 14.6171 7.28983 14.7101C7.3828 14.8038 7.4934 14.8782 7.61526 14.929C7.73712 14.9797 7.86782 15.0059 7.99984 15.0059C8.13185 15.0059 8.26255 14.9797 8.38441 14.929C8.50627 14.8782 8.61687 14.8038 8.70984 14.7101L10.9998 12.4101L13.2898 14.7101C13.3828 14.8038 13.4934 14.8782 13.6153 14.929C13.7371 14.9797 13.8678 15.0059 13.9998 15.0059C14.1318 15.0059 14.2626 14.9797 14.3844 14.929C14.5063 14.8782 14.6169 14.8038 14.7098 14.7101C14.8036 14.6171 14.878 14.5065 14.9287 14.3847C14.9795 14.2628 15.0056 14.1321 15.0056 14.0001C15.0056 13.8681 14.9795 13.7374 14.9287 13.6155C14.878 13.4936 14.8036 13.383 14.7098 13.2901L12.4098 11.0001L14.7098 8.71008C14.8036 8.61712 14.878 8.50652 14.9287 8.38466C14.9795 8.2628 15.0056 8.13209 15.0056 8.00008C15.0056 7.86807 14.9795 7.73736 14.9287 7.6155C14.878 7.49364 14.8036 7.38304 14.7098 7.29008ZM18.0698 3.93008C17.1474 2.97498 16.0439 2.21316 14.8239 1.68907C13.6038 1.16498 12.2916 0.889113 10.9638 0.877575C9.63605 0.866037 8.31926 1.11905 7.09029 1.62186C5.86133 2.12467 4.74481 2.8672 3.80589 3.80613C2.86696 4.74506 2.12443 5.86158 1.62162 7.09054C1.11881 8.3195 0.865793 9.6363 0.877331 10.9641C0.888869 12.2919 1.16473 13.6041 1.68882 14.8241C2.21291 16.0442 2.97473 17.1476 3.92984 18.0701C4.8523 19.0252 5.95575 19.787 7.17579 20.3111C8.39583 20.8352 9.70803 21.111 11.0358 21.1226C12.3636 21.1341 13.6804 20.8811 14.9094 20.3783C16.1383 19.8755 17.2549 19.133 18.1938 18.194C19.1327 17.2551 19.8752 16.1386 20.3781 14.9096C20.8809 13.6807 21.1339 12.3639 21.1223 11.0361C21.1108 9.70827 20.8349 8.39607 20.3109 7.17603C19.7868 5.95599 19.0249 4.85255 18.0698 3.93008ZM16.6598 16.6601C15.3519 17.9695 13.6304 18.7849 11.7886 18.9674C9.94688 19.1499 8.09884 18.6881 6.55936 17.6609C5.01987 16.6336 3.88419 15.1043 3.34581 13.3336C2.80742 11.5628 2.89964 9.66022 3.60675 7.94986C4.31386 6.23951 5.59211 4.82723 7.22373 3.95364C8.85534 3.06006 10.7394 2.79921 12.5548 3.15895C14.3703 3.5187 16.0049 4.49677 17.1801 5.92654C18.3553 7.35631 18.9984 9.14932 18.9998 11.0001C19.0034 12.0514 18.7984 13.0929 18.3968 14.0645C17.9951 15.036 17.4047 15.9182 16.6598 16.6601Z"
                fill="#8B8B8B"
              />
            </svg>
          </div>
          <div class="flex flex-col mt-2 gap-y-1">
            <div class="flex flex-col gap-y-1">
              <span class="text-gray text-xs font-medium"
                >Duration:
                <span class="text-xs text-secondary font-medium">{{
                  `${formatDateString(dates.startDate)} - ${formatDateString(
                    dates.endDate
                  )}`
                }}</span></span
              >

              <span class="text-gray text-xs font-medium"
                >Amount:
                <span class="text-secondary text-xs font-medium"
                  >N{{ proratedSalary.toLocaleString() }}</span
                ></span
              >
            </div>
          </div>
        </div>

        <!-- <div class="my-4 justify-center items-center gap-2 flex">
          <input
            class="my-2"
            v-model="sendOnboardLink"
            type="checkbox"
            name=""
            id=""
          />
          <span class="text-sm text-dark-600"
            >Send employee (s) onboarding form</span
          >
        </div> -->

        <div
          class="w-full my-4 justify-between items-center gap-5 flex md:flex-row flex-col sm:px-12 lg:px-8 xl:px-10"
        >
          <span
            @click="save"
            class="cursor-pointer w-11/12 md:w-6/12 text-center border border-primary grow-0 rounded-full text-primary px-3 text-sm py-3 md:py-3 font-weight-medium"
            >Save and Add More</span
          >
          <div class="w-11/12 md:w-6/12">
            <easiButton class="w-full"> Submit </easiButton>
          </div>
        </div>
      </form>
    </div>

    <div
      v-show="singleAdd === false"
      class="md:w-1/2 w-full py-7 mx-auto bg-white rounded-2xl mt-10 mb-12 relative text-left border border-boxBorder shadow-lg"
    >
      <div class="mb-8">
        <h2
          class="text-center text-headerText font-bold md:text-xl text-lg md:text-2xl"
        >
          Upload Employee
        </h2>
        <hr class="my-3 border-0.5 border-dividerColor text-dividerColor" />
      </div>

      <div class="flex flex-col items-center gap-2 mb-10">
        <span class="text-dark-600 text-xs font-bold mb-1"
          >Download our employee list template and populate it.</span
        >

        <div
          @click="download('employee')"
          class="w-56 flex items-center text-center rounded-full border-none border-secondary py-2 px-4 cursor-pointer"
        >
          <img src="@/assets/icons/download-icon.svg" class="w-5 mr-3" />
          <span class="text-secondary text-base mt-1 text-center font-bold">
            Download Template</span
          >
        </div>
      </div>

      <div class="flex flex-col items-center gap-2 mb-7">
        <span class="text-dark-600 text-xs font-bold mb-1"
          >Upload populated employee list into the system.</span
        >

        <!-- <div
          @click="$refs.input.click()"
          class="w-56 text-center rounded-lg border border-hoverColor py-2 px-4 cursor-pointer"
        >
          <span
            class="w-full justify-center text-hoverColor text-sm text-center font-medium"
          >
            <i class="fas fa-upload mr-3 text-center"></i>Choose File</span
          >
        </div> -->

        <div
          @click="$refs.input.click()"
          class="w-64 mt-2 text-center rounded-xl bg-newGrey border-none border-primary py-2 px-4 cursor-pointer"
        >
          <span
            class="w-full flex items-center gap-3 justify-center text-dark-600 text-base text-center font-bold"
          >
            <img class="w-6" src="@/assets/icons/upload-icon.svg" alt="" />

            <span>Choose File</span>
          </span>
        </div>
        <FileLoader
          v-show="fileLoading"
          :loadNum="loadNumber"
          class="w-9/12 mt-3"
        />
        <input
          v-show="hide === false"
          ref="input"
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          @change="previewFiles($event)"
          type="file"
          class="custom-file-input"
          required
        />

        <div v-show="file" class="flex justify-center gap-4 items-center mt-4">
          <div class="w-6 justify-center self-center">
            <img :src="xlsicon" alt="" />
          </div>

          <p class="text-xs text-dark-900">{{ fileName }}</p>
          <span class="text-xs text-gray">{{ fileSize }}</span>
        </div>

        <div
          v-show="message.length > 0 && fileName.length === 0"
          class="flex justify-center gap-4 items-center"
        >
          <p class="text-xs font-medium text-error">{{ message }}</p>
        </div>
      </div>

      <div class="md:w-9/12 w-11/12 mx-auto my-8">
        <easiButton
          :disabled="fileLoading"
          :loading="buttonLoading"
          block
          @click="openPreviewModal"
          ><span class="font-normal">Preview</span></easiButton
        >
      </div>

      <!-- <form
        @submit.prevent="openPreviewModal"
        autocomplete="on"
        class="flex flex-col items-center px-3 md:px-12 lg:px-8 xl:px-10"
      ></form> -->
    </div>

    <!-- Bulk Employees -->

    <easiModal v-if="addAllowance === true" @close="addAllowance = false">
      <template v-slot:header>
        <h1 class="capitalize font-medium text-headerText">Add Allowance</h1>
      </template>

      <form @submit.prevent="createAllowance" class="mb-5 flex flex-col w-full">
        <div class="text-left px-2 md:px-8 w-full">
          <!-- <label
            for="allowanceName"
            class="text-gray text-left text-xs font-medium"
            >Select from existing allowance</label
          > -->
          <!-- <easiMultiSelectInput
            label="Select from existing allowance"
            :options="allowanceOptions"
            :value="selectedAllowances"
            @update="selectedAllowances = $event"
            name="allowanceName"
            class="mt-1 mb-2 capitalize"
          /> -->

          <!-- <span
            @click="addNew = !addNew"
            class="cursor-pointer text-primary text-center text-sm font-medium my-3"
            >Add New <i v-show="addNew" class="fas fa-angle-right"></i>
            <i v-show="!addNew" class="fas fa-angle-down"></i>
          </span> -->
          <!-- <label
            for="allowanceName"
            class="text-gray text-left text-xs font-medium"
            >Allowance Name</label
          > -->
          <TextInput
            placeholder="Enter Allowance name"
            v-model="allowanceArg.name"
            type="text"
            name="allowanceName"
            class="mt-1 mb-5 px-8 max-w-full"
          />
        </div>
        <hr
          class="mt-7 mb-4 border-0.5 border-dividerColor text-dividerColor"
        />
        <div class="px-2 md:px-8 w-full md:w-64 justify-center mx-auto">
          <Button :loading="loading.add" block class="w-full">Submit</Button>
        </div>
      </form>
    </easiModal>

    <easiModal
      v-if="prorate === true"
      @close="prorate = false"
      :isBorder="false"
    >
      <template v-slot:header>
        <h1 class="capitalize font-semibold text-headerText">Prorate Salary</h1>
      </template>

      <form
        v-if="!prorated"
        @submit.prevent="prorateSalary"
        class="my-5 flex flex-col w-full"
      >
        <div class="flex flex-col items-start px-2 md:px-8">
          <label
            for="startDate"
            class="text-dark-600 text-left text-xs mt-2 font-medium"
            >Start Date
          </label>
          <input
            placeholder="Select Start Date"
            required
            v-model="dates.startDate"
            type="date"
            name="startDate"
            class="mt-1 mb-5 px-2 md:px-8 rounded-2xl w-full border border-dark-200"
          />
        </div>
        <div class="flex flex-col items-start px-2 md:px-8">
          <label
            for="startDate"
            class="text-dark-600 text-left text-xs mt-2 font-medium"
            >End Date
          </label>
          <input
            placeholder="Select Start Date"
            required
            :min="dates.startDate"
            v-model="dates.endDate"
            type="date"
            name="startDate"
            class="mt-1 mb-5 px-2 md:px-8 rounded-2xl w-full border border-dark-200"
          />
        </div>

        <div class="flex flex-col w-full items-start px-2 md:px-8">
          <label
            for="weekendWork"
            class="text-dark-600 text-left text-xs mt-2 font-medium"
            >Select number of weekend work deduction
          </label>
          <easiSelectInput2
            required
            class="mt-1 mb-2 w-full text-left"
            @update="prorateArg.weekendDay = $event"
            :value="prorateArg.weekendDay"
            :options="prorateOption"
          />
        </div>

        <div class="flex flex-col items-start px-2 md:px-8">
          <label
            for="holidays"
            class="text-dark-600 text-left text-xs mt-2 font-medium"
            >Select number of holiday(s) to deduct
          </label>
          <easiSelectInput2
            required
            class="mt-1 mb-2 w-full text-left"
            @update="prorateArg.holidays = $event"
            :value="prorateArg.holidays"
            :options="holidaysArray"
            :grid="true"
          />
        </div>

        <div class="px-2 md:px-8 mt-4 w-full justify-center mx-auto">
          <Button class="w-full">Submit</Button>
        </div>
      </form>

      <div v-else class="items-center flex w-full flex-col gap-y-1">
        <span class="text-dark-600 text-sm font-medium">Duration:</span>
        <span class="text-secondary font-medium">{{
          `${formatDateString(dates.startDate)} - ${formatDateString(
            dates.endDate
          )}`
        }}</span>

        <span class="text-dark-600 text-sm font-medium">Amount:</span>
        <span class="text-primary text-2xl font-medium"
          >N{{ proratedSalary.toLocaleString() }}</span
        >
        <div class="w-9/12">
          <easiButton
            @click="
              () => {
                prorate = false;
              }
            "
            :block="true"
            class="my-6 w-full"
            >Submit</easiButton
          >
        </div>
      </div>
    </easiModal>

    <easiSuccess v-if="addSalarySuccess" @close="addSalarySuccess = false">
      <template v-slot:message>
        <span>Employee(s) added successfully</span>
      </template>
    </easiSuccess>

    <easiPreview v-if="previewModal" @close="reloadPage">
      <template v-slot:header>
        <h1>{{ uploaded ? "Confirm" : "Preview" }} Upload</h1>
        <p
          v-if="bankInvalid"
          class="text-error-table font-bold text-base mt-7 mb-2"
        >
          Invalid bank details found
        </p>
        <p
          v-if="errorFound"
          class="text-error-table font-bold text-base mt-7 mb-2"
        >
          The highlighted section(s) need to be corrected. Please correct and
          submit
        </p>
      </template>

      <template v-slot:body>
        <!-- <div v-if="jsonData.length && uploaded === false" class="w-full">
          <easiTable
            :data="jsonData"
            :header="configureHeaders"
            :mapData="bankCodes"
            :useSelect="['Bank Code']"
            :frozenFields="['Employee Id', 'First Name', 'Last Name']"
            :highlight="['First Name', 'Last Name']"
            :mandatory="['First Name', 'Last Name']"
            :amountValues="['grossAmount', 'grossPay', 'Gross Pay']"
            :readonly="true"
          ></easiTable>
        </div> -->

        <div class="w-full">
          <easiTable
            :data="uploadJsonData"
            :header="uploadHeaders"
            :mapData="bankCodes"
            :useSelect="['bankCode']"
            :frozenFields="['sr', 'firstName', 'lastName']"
            :highlight="['firstName', 'lastName']"
            :mandatory="['firstName', 'lastName']"
            :amountValues="['grossAmount', 'grossPay']"
          ></easiTable>
        </div>

        <div class="flex flex-col justify-center gap-y-4 mt-4 mb-3 w-full">
          <!-- <div class="justify-center items-center gap-2 flex w-full">
            <input
              class="my-2"
              v-model="sendOnboardLink"
              type="checkbox"
              name=""
              id=""
            />
            <span class="text-lg font-bold text-center text-dark-600"
              >Send employee (s) onboarding form</span
            >
          </div> -->

          <div class="self-center flex justify-center w-full text-base">
            <!-- <easiButton
              class="md:w-72 w-96"
              v-if="uploaded === false"
              @click="doUpload(false, 'employee')"
              >Submit</easiButton
            > -->
            <easiButton class="md:w-72 w-96" @click="uploadToServer"
              >Submit</easiButton
            >
          </div>
        </div>
      </template>
    </easiPreview>

    <easiModal v-if="addDept" @close="addDept = false" :isHeader="false">
      <AddDept @close="addDept = false" :type="true" />
    </easiModal>

    <easiLoading v-if="loadingBank" @close="loadingBank = false">
      <template v-slot:heading>
        <h1>Verifying Bank Information</h1>
      </template>

      <template v-slot:message>
        <div class="w-full rounded-xl">
          <vue3-progress-bar></vue3-progress-bar>
        </div>
      </template>
    </easiLoading>

    <easiLoading v-if="loadingProgress" @close="loadingProgress = false">
      <template v-slot:heading>
        <h1>Analyzing Data</h1>
      </template>

      <template v-slot:message>
        <div class="w-full rounded-xl">
          <vue3-progress-bar></vue3-progress-bar>
        </div>
      </template>
    </easiLoading>

    <easiRoundLoader v-if="loading.add" />
  </main>
</template>

<script>
import * as XLSX from "xlsx/xlsx.mjs";
import data from "./data.JSON";
import axios from "axios";
import { AUTH_CONTEXT } from "@/api/api";
import { useProgress } from "@marcoschulte/vue3-progress";

import { ref, watch, reactive, computed, onBeforeUnmount } from "vue";
import { mapWritableState, storeToRefs } from "pinia";
import { useDataStore } from "@/stores/data.js";
import { mapActions, mapState } from "pinia";
import { useToast } from "vue-toastification";
import { helperFunctions } from "@/composable/helperFunctions";
import FileLoader from "@/components/global/FileLoader.vue";

import AddDept from "@/components/Settings/Edit/Dept.vue";

import Button from "@/components/global/Button.vue";
import TextInput from "@/components/global/TextInput.vue";
import banks from "@/utils/banks";
import benefitsOptions from "@/utils/benefits";
import prorateIcon from "@/assets/icons/prorate.svg";
import xlsicon from "@/assets/icons/xls.svg";
import { prorateNet } from "@/composable/mixins/prorate";
import { onBeforeRouteLeave } from "vue-router";
export default {
  mixins: [prorateNet],
  setup() {
    const store = useDataStore();
    const { query } = store;
    const { allowance, listEmployees } = storeToRefs(store);
    const toast = useToast();
    const { formatDateString } = helperFunctions;

    function toStore(salary, prorate) {
      store.$patch((state) => {
        state.salaryArray.push({ salary, prorate });
      });
    }

    function isExpired(expiryDateStr) {
      if (expiryDateStr || !expiryDateStr) {
        return false;
      }
      const expiryDate = new Date(expiryDateStr);
      const currentDate = new Date();
      return expiryDate < currentDate;
    }

    const allDepartments = computed(() =>
      store.getAllDepartments &&
      store.getAllDepartments.data &&
      Array.isArray(store.getAllDepartments.data) &&
      store.getAllDepartments.data.length
        ? store.getAllDepartments.data.map((dep) => {
            return { label: dep.name, value: dep._id };
          })
        : []
    );

    const departmentOptions = ref(allDepartments.value);

    watch(allDepartments, (val) => {
      departmentOptions.value = val;
    });

    const queryDepartment = async () => {
      try {
        await query({
          endpoint: "ListDepartments",
          service: "SETTINGS",
          storeKey: "listDepartments",
        });
        departmentOptions.value = allDepartments.value;
      } catch (err) {
        console.log(err);
      }
    };
    queryDepartment();

    const queryBonus = async () => {
      // loading.value = true;
      try {
        await query({
          endpoint: "ListBonusAndDeduction",
          payload: {
            input: {
              paging: {
                limit: 1000,
                skip: 0,
                search: "",
              },
              type: "Bonus",
            },
          },
          service: "PAYROLL",
          storeKey: "bonuses",
        });
        // console.log(getBonusAndDeduction.value, "After query");
      } catch (err) {
        console.log(err);
      }
    };
    queryBonus();

    const queryDeduction = async () => {
      // loading.value = true;
      try {
        await query({
          endpoint: "ListBonusAndDeduction",
          payload: {
            input: {
              paging: {
                limit: 1000,
                skip: 0,
                search: "",
              },
              type: "Deduction",
            },
          },
          service: "PAYROLL",
          storeKey: "deductions",
        });
        // console.log(getBonusAndDeduction.value, "After query");
      } catch (err) {
        console.log(err);
      }
    };
    queryDeduction();

    const bonusOptions = computed(() => {
      let data = [];
      if (store.getAllBonuses && store.getAllBonuses.length) {
        data = store.getAllBonuses.map((bonus) => {
          if (!isExpired(bonus.endDate)) {
            return {
              label: bonus.name,
              value: bonus._id,
            };
          }
        });
      }

      const filteredData = data.filter((el) => typeof el !== "undefined");
      return filteredData;
    });

    const deductionOptions = computed(() => {
      let data = [];
      if (store.getAllDeductions && store.getAllDeductions.length) {
        data = store.getAllDeductions.map((ded) => {
          if (!isExpired(ded.endDate)) {
            return {
              label: ded.name,
              value: ded._id,
            };
          }
        });
      }

      const filteredData = data.filter((el) => typeof el !== "undefined");
      return filteredData;
    });

    // store.$subscribe((mutation, state) => {
    //   console.log(mutation.type, mutation.storeId, mutation.payload, state);
    //   // store.allowance = mutation.payload;
    // });

    onBeforeRouteLeave((to, from, next) => {
      if (
        confirm(
          "You are about to leave this page. Are you sure you want to continue?"
        )
      ) {
        // User confirmed, continue with navigation
        next();
      } else {
        // User canceled, stay on the current page
        next(false);
      }
    });
    const handleBeforeUnload = (event) => {
      const confirmationMessage =
        "You have unsaved changes. Are you sure you want to leave?";
      event.returnValue = confirmationMessage;
      return confirmationMessage;
    };
    onBeforeUnmount(() => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    });

    window.addEventListener("beforeunload", handleBeforeUnload);

    return {
      store,
      query,
      allowance,
      toast,
      listEmployees,
      toStore,
      formatDateString,
      departmentOptions,
      bonusOptions,
      deductionOptions,
    };
  },
  components: {
    Button,
    TextInput,
    AddDept,
    FileLoader,
  },
  data() {
    return {
      loadNumber: 0,
      buttonLoading: false,
      successfullyUploaded: [],
      addDept: false,
      addNew: false,
      staticAllowances: ["basic", "transport", "housing"],
      errorRules: {
        userInput: "",
        email: "",
      },
      today: "",
      sameAsPrevious: false,
      tempUserName: "",
      allowstepTwo: false,
      clearObj: false,
      proratedSalary: 0,
      prorated: false,
      benefitsOptions,
      validate: true,
      holidaysArray: [],
      allPhoneNumbers: [],
      allEmails: [],
      prorateOption: [
        {
          label: "NONE",
          value: "NONE",
        },
        {
          label: "Saturday",
          value: "SATURDAY",
        },
        {
          label: "Sunday",
          value: "SUNDAY",
        },
        {
          label: "Saturday and Sunday",
          value: "BOTH",
        },
      ],
      loadingProgress: false,
      fileLoading: false,
      loadingBank: false,
      progressValue: 0,
      options: {
        text: {
          color: "#FFFFFF",
          shadowEnable: true,
          shadowColor: "#000000",
          fontSize: 14,
          fontFamily: "Helvetica",
          dynamicPosition: false,
          hideText: false,
        },
        progress: {
          color: "#2dbd2d",
          backgroundColor: "#333333",
          inverted: false,
        },
        layout: {
          height: 35,
          width: 140,
          verticalTextAlign: 61,
          horizontalTextAlign: 43,
          zeroOffset: 0,
          strokeWidth: 30,
          progressPadding: 0,
          type: "line",
        },
      },
      sheetStyle: {
        border: "1px solid #B5BDE1",
        fontSizee: "14px",
      },
      accountWarning: "",
      previewModal: false,
      hide: true,
      message: "",
      fileName: "",
      fileSize: "",
      addSalarySuccess: false,
      currentEmployee: {},
      newEmployee: {},
      addAllowance: false,
      prorate: false,
      allowanceArg: {
        name: "",
      },
      dates: {
        startDate: "",
        endDate: "",
      },
      prorateArg: {
        month: 0,
        year: 0,
        days: 0,
        weekendDay: "BOTH",
        holidays: 0,
      },
      prorateIcon,
      xlsicon,
      nigerianBanks: banks,
      allowanceData: [],
      payload: {
        paging: {
          limit: 1000,
          skip: 0,
          search: "",
          sort: { firstName: "ASC" },
        },
        filter: [],
      },
      payload2: {
        paging: {
          limit: 1000,
          skip: 0,
          search: null,
        },
      },

      profileData: {
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
      },
      statutoryData: {
        pensionProvider: "",
        employeePensionPin: "",
      },
      jobData: {
        branchId: "",
        departmentId: "",
        jobTitle: "",
        employmentType: "",
      },
      sendOnboardLink: false,
      singleAdd: true,
      empDetails: true,
      bankName: "",
      bankDetails: [],
      salaryArg: {
        grossPay: 0,
        deduction: [],
        accountNumber: "",
        accountName: "",
      },
      inviteArg: {
        employeeId: "",
      },
      bankArgs: {
        bankName: "",
        bankCode: "",
        accountNumber: "",
        accountName: "",
      },
      args: {
        staffLevel: {
          benefits: [],
          grossAmount: "",
          wht: {
            amount: 0,
            paymentTypes: [],
            percentage: 0,
          },
          hmo: {
            provider: "",
            amount: 0,
            duration: "MONTHLY",
            plan: "GOLD",
            chargeTo: "EMPLOYEE",
          },
          lifeInsurance: {
            provider: "",
            amount: 0,
            duration: "MONTHLY",
          },
          lifeAssurance: {
            provider: "",
            amount: 0,
            duration: "MONTHLY",
            chargeTo: "EMPLOYEE",
          },
          itf: {
            amount: 0,
          },
          nsitf: {
            amount: 0,
          },
          pension: {
            amount: 0,
            provider: "",
            employerPensionContribution: 0,
            employeePensionContribution: 0,
            providerPin: "",
            usePercentage: false,
            manually_inputted: false,
            employeePensionPin: "",
          },
          paye: {
            amount: 0,
            stateForPaye: "",
            taxId: "",
          },
          nhf: {
            amount: 0,
          },
          gratuity: {
            salaryAmount: 0,
            yearsWorked: 0,
            amount: 0,
          },
          businessExpense: { amount: 0, expenseName: "" },

          allowanceDetails: [],
          withholdingTax: false,
          usePercentageForAllowance: true,
        },
        departmentId: "",
        bonusIds: [],
        deductionIds: [],
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        userName: "",
        title: "",
        gender: "",

        jobTitle: "",
        employmentType: "",

        bankName: "",
        bankCode: "",
        accountNumber: "",
        accountName: "",
      },

      configureUploadHeaders: [],
      uploadJsonData: [],
      jsonData: [],

      btnState: "primary",
      uploaded: false,
      file: null,
      employeeSheet: [],
      argsArray: [],
      bankInvalid: false,
      errorFound: false,
      holdAllowanceDetails: [],
      loading: {
        table: false,
        sendInvite: false,
        add: false,
      },
      errorCaught: false,
      tempBen: [],
      allowanceToHide: [],
      totalAllowanceValue: 0,
      selectedAllowances: [],
    };
  },
  computed: {
    ...mapWritableState(useDataStore, [
      "listAllowance",
      "allowance",
      "count",
      "name",
      "doubleCount",
      "getAllEmployees",
      "salaryData",
      "getCompanyDetails",
      "tempBenData",
      "tempBonusData",
      "tempDeductionData",
      "tempAllowData",
      "getUserName",
      "userName",
      "getSuccessNumber",
    ]),
    doubleValue: (store) => store.doubleCount,
    addedEmps: (store) => store.getSuccessNumber,
    allAllowanceData: (store) => store.listAllowance,
    allEmployees: (store) => store.getAllEmployees,
    salaryArgsFromStore: (store) => store.salaryData,
    benFromStore: (store) => store.tempBenData,
    bonusFromStore: (store) => store.tempBonusData,
    deductionFromStore: (store) => store.tempDeductionData,
    allowanceFromStore: (store) => store.tempAllowData,
    companyData: (store) => store.getCompanyDetails,
    lastUserName: (store) => store.getUserName,
    accNum() {
      return this.args.accountNumber;
    },
    mailAddress() {
      return this.args.email;
    },
    cellNumber() {
      return this.args.phoneNumber;
    },
    bankCodes() {
      // const bankCodeObj = this.nigerianBanks.reduce(
      //   (acc, cur) => ({ ...acc, [cur.code]: cur.name }),
      //   {}
      // );
      const bankArray = [];
      for (let bank of this.nigerianBanks) {
        bankArray.push({
          label: bank.name,
          value: bank.code,
        });
      }
      return bankArray;
    },
    label() {
      return (str) =>
        str
          .split(".")
          .pop()
          .replace(/([A-Z])/g, " $1")
          .toUpperCase();
    },
    configureHeaders() {
      let headArr = [];
      const head = Object.keys(this.jsonData[0]);
      for (let i of head) {
        headArr.push({
          field: i,
          header: i,
        });
      }
      return headArr;
    },

    uploadHeaders() {
      let headArr = [];
      // const head = Object.keys(this.uploadJsonData[0]);
      const head = this.uploadJsonData[0];
      for (const i in head) {
        headArr.push({
          field: i,
          header: i,
        });
      }
      return headArr;
    },
    benefits() {
      return this.args.staffLevel.benefits;
    },
    allowanceOptions() {
      const data = this.allAllowanceData.data.map((da) => {
        return {
          label: da.name,
          value: da._id,
        };
      });
      const filterData = data.filter(
        (d) => !this.staticAllowances.includes(d.label)
      );
      return filterData;
    },
  },
  watch: {
    mailAddress() {
      if (this.args.email) {
        const alph = /[a-z]/i;
        const validRegex =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        const lastStr = this.args.email.charAt(this.args.email.length - 1);
        if (lastStr === "@") this.errorRules.email = "";
        if (
          !lastStr.match(validRegex) &&
          !lastStr.match(alph) &&
          !/\d/.test(lastStr)
        ) {
          this.errorRules.email = "Please enter a valid email address";
        } else if (
          this.allEmails.length &&
          this.allEmails.includes(this.args.email)
        ) {
          this.errorRules.email = "Email already in use.";
        } else {
          this.errorRules.email = "";
        }
      }
    },
    cellNumber() {
      if (this.args.phoneNumber.length > 0) {
        if (
          this.args.phoneNumber.charAt(0) == 0 &&
          this.args.phoneNumber.length > 11
        ) {
          this.errorRules.userInput = "Please enter a valid phone number";
          ``;
        } else if (
          this.args.phoneNumber.charAt(0) == 2 &&
          this.args.phoneNumber.length > 13
        ) {
          this.errorRules.userInput = "Please enter a valid phone number";
          ``;
        } else if (
          this.allPhoneNumbers.length &&
          this.allPhoneNumbers.includes(
            this.processNumber(this.args.phoneNumber)
          )
        ) {
          this.errorRules.userInput = "Phone number already in use.";
        } else {
          this.errorRules.userInput = "";
        }
      }
    },
    accNum: function (val) {
      if (this.args.accountNumber.length === 10) {
        // this.verify = true;
        // await this.verifyAccountName();
        console.log(this.args.staffLevel);
        this.verifyAccountName();
      }
    },
    bankName: function (val) {
      this.bankDetails = [];
      this.bankDetails = this.nigerianBanks.filter((bank) => bank.name === val);
      for (let bank of this.bankDetails) {
        this.args.bankName = bank.name;
        this.args.bankCode = bank.code;
      }
    },
    // benefits: {
    //   function(newval, oldval) {
    //     const onePercent = this.calculatePercentage(
    //       this.args.staffLevel.grossAmount,
    //       1
    //     );
    //     const twoPointFive = this.calculatePercentage(
    //       this.args.staffLevel.grossAmount,
    //       2.5
    //     );
    //     if (newval.includes("nsitf")) {
    //       this.args.staffLevel.nsitf.amount = onePercent;
    //     }
    //     if (newval.includes("itf")) {
    //       console.log("HEY");
    //       this.args.staffLevel.itf.amount = twoPointFive;
    //       console.log(staffLevel.itf.amount);
    //     }
    //     if (newval.includes("nhf")) {
    //       this.args.staffLevel.nhf.amount = twoPointFive;
    //     }
    //     console.log("EVENTFUL", this.args.staffLevel);
    //   },
    //   deep: true,
    // },
  },
  methods: {
    ...mapActions(useDataStore, ["query", "mutate"]),
    reloadPage() {
      this.buttonLoading = false;
      this.bankInvalid = false;
      this.errorFound = false;
      this.uploaded = false;
      this.jsonData = [];
      this.uploadJsonData = [];
      this.file = null;
      this.$refs.input.value = "";
      this.fileName = "";
      this.message = "";
      this.previewModal = false;
    },
    hideAllowance(allowanceId) {
      this.allowanceToHide.push(allowanceId);
      this.selectedAllowances = this.selectedAllowances.filter(
        (al) => !this.allowanceToHide.includes(al)
      );
    },
    toggleAllowance(e) {
      this.selectedAllowances = e;
      this.allowanceToHide = this.allowanceToHide.filter(
        (ad) => !this.selectedAllowances.includes(ad)
      );
    },
    containsSpecialChars(str) {
      const specialChars = /[ `!#$%^&*()_+\-=\[\]{};':"\\|,<>\/?~]/;
      // const num = str.replace(/[^.]/g, "").length;
      // const num1 = str.replace(/[^@]/g, "").length;

      return specialChars.test(str);
    },
    validateEmail() {
      let validRegex =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (this.args.email && this.args.email.length) {
        if (
          this.args.email.match(validRegex) &&
          !this.containsSpecialChars(this.args.email)
        ) {
          return true;
        } else if (
          this.args.email.length &&
          this.allEmails.length &&
          this.allEmails.includes(this.args.email)
        ) {
          this.errorRules.email = "Email already in use.";
          return false;
        }
      }
      return true;
    },
    validatePhone() {
      if (this.args.phoneNumber.length > 0) {
        if (this.args.phoneNumber.trim() == "") {
          this.errorRules.userInput = "Please fill in your phone number";
          return false;
        } else if (
          this.args.phoneNumber.charAt(0) == 0 &&
          this.args.phoneNumber.length !== 11
        ) {
          this.errorRules.userInput = "Please enter a valid phone number";
          return false;
        } else if (
          this.args.phoneNumber.charAt(0) == 2 &&
          this.args.phoneNumber.length !== 13
        ) {
          this.errorRules.userInput = "Please enter a valid phone number";
          return false;
        } else if (
          this.allPhoneNumbers.length &&
          this.args.phoneNumber.length &&
          this.allPhoneNumbers.includes(
            this.processNumber(this.args.phoneNumber)
          )
        ) {
          this.errorRules.userInput = "Phone number already in use.";
          return false;
        } else {
          // errorRules.email = false;
          // errorRules.pin = false;

          return true;
        }
      }
      return true;
    },
    usePrevious() {
      if (this.sameAsPrevious) {
        const lastObj =
          this.salaryArgsFromStore[this.salaryArgsFromStore.length - 1];

        this.args.staffLevel = Object.assign({}, lastObj.salary.staffLevel);
        // console.log(lastObj, "LAST OBHJ", this.args.staffLevel);
        // this.allowanceData = this.allowanceFromStore;

        // this.$nextTick(() => {
        //   this.args.bonusIds =
        //     this.bonusFromStore[this.bonusFromStore.length - 1];
        //   this.args.deductionIds =
        //     this.deductionFromStore[this.deductionFromStore.length - 1];
        //   if (this.benFromStore.length > 0) {
        //     const lastNestedArray =
        //       this.benFromStore[this.benFromStore.length - 1];
        //     for (const item of lastNestedArray) {
        //       this.tempBen.push(item);
        //     }
        //   }
        // });

        if (this.args.staffLevel.usePercentageForAllowance) {
          this.allowanceData = this.args.staffLevel.allowanceDetails.reduce(
            (acc, cur) => ({ ...acc, [cur.allowanceId]: cur.percentage }),
            {}
          );
          // console.log(this.allowanceData);
        } else {
          this.allowanceData = this.args.staffLevel.allowanceDetails.reduce(
            (acc, cur) => ({ ...acc, [cur.allowanceId]: cur.amount }),
            {}
          );
        }
        console.log(this.allowanceData, this.tempBen);
      } else {
        this.allowanceData = [];
        this.tempBen = [];
        this.args.staffLevel = {
          benefits: [],
          grossAmount: 0,
          hmo: {
            provider: "",
            amount: 0,
            duration: "",
            plan: "",
            chargeTo: "EMPLOYEE",
          },
          lifeInsurance: {
            provider: "",
            amount: 0,
            duration: "",
          },
          lifeAssurance: {
            provider: "",
            amount: 0,
            duration: "",
            chargeTo: "EMPLOYEE",
          },
          itf: {
            amount: 0,
          },
          nsitf: {
            amount: 0,
          },
          pension: {
            amount: 0,
            provider: "",
            employerPensionContribution: 0,
            employeePensionContribution: 0,
            providerPin: "",
            usePercentage: false,
            manually_inputted: false,
            employeePensionPin: "",
          },
          paye: {
            amount: 0,
            stateForPaye: "",
            taxId: "",
          },
          nhf: {
            amount: 0,
          },
          gratuity: {
            salaryAmount: 0,
            yearsWorked: 0,
            amount: 0,
          },
          wht: {
            amount: 0,
            paymentTypes: [],
            percentage: 0,
          },
          businessExpense: { amount: 0, expenseName: "" },

          allowanceDetails: [],
          withholdingTax: false,
          usePercentageForAllowance: true,
        };
      }
    },
    async sendInvite(empArray) {
      this.loading.sendInvite = true;

      let res;

      try {
        res = await this.mutate({
          endpoint: "SendLinkForEmployeeOnboarding",
          data: { input: { employeeIds: empArray } },
          service: "EMP",
        });
      } catch (err) {
        console.log(err);
        this.loading.sendInvite = false;
      }
      this.loading.sendInvite = false;
      if (res.success) {
        // this.toast.success("Onboarding Link Successfully Sent.");
      }
    },
    checkUpdate(event) {
      console.log(event, "EVES");
      this.args.staffLevel = Object.assign({}, event);
      this.tempBen = event.benefits;

      // const checkArray = [
      //   "paye",
      //   "pension",
      //   "hmo",
      //   "lifeInsurance",
      //   "lifeAssurance",
      //   "wht",
      //   "nsitf",
      //   "itf",
      //   "gratuity",
      //   "nhf",
      //   "businessExpense",
      // ];

      // for (let check of checkArray) {
      //   if (!this.args.staffLevel.benefits.includes(check)) {
      //     delete this.args.staffLevel[check];
      //   }
      // }
    },
    calculatePercentage(num, per) {
      const result = (Number(num) / 100) * Number(per);
      return this.truncateAmount(result);
    },
    resetObj(obj, objName) {
      this[objName] = Object.keys(obj).reduce((acc, curr) => {
        if (obj[curr] === null) return { ...acc, [curr]: null };
        if (typeof obj[curr] === "undefined")
          return { ...acc, [curr]: undefined };
        // if (typeof obj[curr] === "boolean") return { ...acc, [curr]: false }; //Handle Booleans separately
        if (typeof obj[curr] === "string") return { ...acc, [curr]: "" };
        if (typeof obj[curr] === "number") return { ...acc, [curr]: 0 };
        if (obj[curr] instanceof Array) return { ...acc, [curr]: [] };
        if (typeof obj[curr] === "object") return { ...acc, [curr]: {} };
      }, {});
    },
    clearProrate() {
      this.resetObj(this.prorateArg, "prorateArg");
      this.resetObj(this.dates, "dates");
      this.prorated = false;
      this.proratedSalary = 0;
    },
    generateUserName() {
      console.log("mounted");
      const length = Number(this.generateRandomNumber());
      const companyName =
        this.companyData &&
        this.companyData.company &&
        this.companyData.company.companyName
          ? this.companyData.company.companyName
          : "Employee";
      const arr = companyName ? companyName.split(" ") : [];
      // if (this.salaryArgsFromStore.length) {
      //   const length =
      //     Number(this.lastUserName.charAt(this.lastUserName.length - 1)) + 1;
      //   this.args.userName = this.lastUserName.replace(/.$/, `${length}`);
      //   console.log(this.args.userName);
      // }
      if (this.allEmployees && this.allEmployees.count) {
        if (arr && arr.length && arr[0].length >= 4) {
          const firstFour = arr[0].substring(0, 4);

          const result = this.checkIfUserNameExists(`${firstFour}-${length}`)
            ? `${firstFour}-${length + 1}`
            : `${firstFour}-${length}`;
          this.args.userName = result;
          this.tempUserName = result;
        } else {
          const sub = arr[0].length;
          const pre = arr[0].substring(0, sub);
          // const length = Number(this.allEmployees.count + 1);
          const result = this.checkIfUserNameExists(`${pre}-${length}`)
            ? `${pre}-${length + 1}`
            : `${pre}-${length}`;
          this.tempUserName = result;
          this.args.userName = result;
        }
      } else {
        if (arr && arr.length && arr[0].length >= 4) {
          const firstFour = arr[0].substring(0, 4);
          const result = `${firstFour}-${length}`;
          this.tempUserName = result;
          this.args.userName = result;
        } else {
          const sub = arr[0].length;
          const pre = arr[0].substring(0, sub);
          const result = `${pre}-${length}`;
          this.tempUserName = result;
          this.args.userName = result;
        }
      }
    },
    async save() {
      this.errorCaught = false;
      try {
        if (!this.args.accountName.length) {
          this.toast.error("Add bank account details to continue");
          throw new Error("Missing details");
        }
        const more = this.addMore(this.args, this.prorateArg);
        if (more === false) {
          throw new Error("Bad user input");
        }

        await this.allowanceComplete(false);
        if (this.errorCaught === false) {
          // this.resetObj(this.prorateArg, "prorateArg");
          this.prorateArg = {
            month: 0,
            year: 0,
            days: 0,
            weekendDay: "BOTH",
            holidays: 0,
          };
          this.resetObj(this.args, "args");
          this.sameAsPrevious = false;
          this.allowanceData = [];
          this.tempBen = [];
          this.clearObj = true;
          this.args.staffLevel.benefits = [];
          this.args.staffLevel.allowanceDetails = [];
          this.args.bonusIds = [];
          this.args.deductionIds = [];
          this.bankName = "";

          // this.allowanceData = [];
          this.empDetails = true;
          // this.generateUserName();

          this.toast.success("Employee Details saved");

          setTimeout(() => {
            window.location.reload();
          }, 1000);
        }
      } catch (e) {
        console.log(e);
      }
    },
    addMore(salary, prorate) {
      try {
        if (this.args.firstName.length) {
          if (
            (this.args.email && this.args.email.length === 0) ||
            !this.args.email
          ) {
            delete this.args["email"];
          }
          if (
            (this.args.gender && this.args.gender.trim().length === 0) ||
            !this.args.gender
          ) {
            delete this.args["gender"];
          }
          // if (
          //   this.tempUserName === this.args.userName &&
          //   this.salaryArgsFromStore.length
          // ) {
          //   const lastObj =
          //     this.salaryArgsFromStore[this.salaryArgsFromStore.length - 1];
          //   const lastUserNameFromStore = lastObj.userName;
          //   console.log(lastUserNameFromStore, "ASKDRY");

          //   const length =
          //     Number(this.args.userName.charAt(this.args.userName.length - 1)) +
          //     1;
          //   this.args.userName = this.args.userName.replace(/.$/, `${length}`);
          //   this.store.$patch((state) => {
          //     state.userName = this.args.userName;
          //   });
          // } else {
          //   this.store.$patch((state) => {
          //     state.userName = this.args.userName;
          //   });
          // }

          const validated = this.validateAllowanceThenNext();
          if (validated !== false) {
            this.processArgs();
            this.transformAllowances();
          } else {
            return false;
          }

          this.argsArray.push({
            salary,
            prorate,
          });

          this.store.$patch((state) => {
            state.salaryArray.push({ salary, prorate });
            state.tempStoreBen.push(this.tempBen);
            state.tempBonusIds.push(this.args.bonusIds);
            state.tempDeductionIds.push(this.args.deductionIds);
            state.tempAllowanceData.push(this.allowanceData);
          });

          return this.argsArray;
        }
      } catch (e) {
        console.log(e);
        return false;
      }
    },

    download(template) {
      if (template == "employee") {
        this.btnState = "disabled";
        let host = window.location.protocol + "//" + window.location.host;
        axios({
          url: `${host}/uploads/Employee.xlsx`,
          method: "GET",
          responseType: "blob",
        }).then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", "Employee.xlsx");
          document.body.appendChild(fileLink);
          fileLink.click();
          this.btnState = "outline";
        });
      }
    },
    // onDelete(records) {
    //   records = records.map((rec) => ["del", rec.keys.join()]);
    //   redis.multi(records).exec();
    // },
    setBasicAllowance() {
      let temp = 0;
      let temp2 = 0;
      let temp3 = 0;
      let allowanceArr = [];
      for (let field of this.allAllowanceData.data) {
        if (field.name.toLowerCase() == "basic") {
          temp = field._id;
        }
        if (field.name.toLowerCase() == "housing") {
          temp2 = field._id;
        }
        if (field.name.toLowerCase() == "transport") {
          temp3 = field._id;
        }
      }
      allowanceArr.push(
        {
          allowanceId: temp,
          percentage: 50,
        },
        {
          allowanceId: temp2,
          percentage: 30,
        },
        {
          allowanceId: temp3,
          percentage: 20,
        }
      );
      return allowanceArr;
    },
    transformObject(arr) {
      // //remove string preceeding the "." sign
      const newArr = arr.dataFromExcel.map((obj) =>
        Object.fromEntries(
          Object.entries(obj).map(([k, v]) => [k.split(".").pop(), v])
        )
      );

      if (Object.keys(arr.dataFromExcel[0]).includes("bankError")) {
        const findError = newArr.find((item) => item.bankError.length > 0);
        if (findError) {
          this.bankInvalid = true;
        }
      }
      for (let k of Object.keys(arr.errors)) {
        for (let data of newArr) {
          if (Number(k) === data.sr) {
            data["errors"] = arr.errors[k];
            console.log(data);
          }
        }
      }

      this.uploadJsonData = newArr;

      this.$nextTick();
    },
    removeNullValues(obj) {
      const { salary } = obj;
      if (salary) {
        const updatedSalary = Object.entries(salary)
          .filter(function (entry) {
            return entry[1] !== null;
          })
          .reduce(function (acc, entry) {
            acc[entry[0]] = entry[1];
            return acc;
          }, {});
        return { salary: updatedSalary };
      }
      return obj;
    },
    createUploadArray() {
      const profile = this.uploadJsonData.map((item) => {
        return {
          salary: {
            // sr: String(item.sr),
            departmentId: "",
            bonusIds: [],
            deductionIds: [],
            phoneNumber:
              item.phone && String(item.phone).length
                ? this.processNumber(String(item.phone))
                : null,
            email: item.email && item.email.length ? item.email : null,
            firstName: item.firstName,
            lastName: item.lastName,
            jobTitle: item.jobTitle,
            employmentType: item.employmentType
              ? item.employmentType
              : "FULLTIME",
            accountNumber: String(item.accountNumber),
            bankName: item.bankName,
            accountName: item.accountName ? item.accountName : "",
            bankCode: String(item.bankCode),
            staffLevel: {
              allowanceDetails: this.setBasicAllowance(),
              withholdingTax: false,
              usePercentageForAllowance: true,
              benefits: [
                item.pension_provider ? "Pension" : null,
                item.hmo_provider ? "HMO" : null,
                item.taxId ? "PAYE" : null,
              ].filter((el) => el != null || el != undefined),
              grossAmount: Number(item.grossAmount) || 0,
              lifeInsurance: {
                provider: item.lifeInsurance_provider
                  ? item.lifeInsurance_provider
                  : "",
              },
              // lifeAssurance: {
              //   provider: item.lifeAssurance_provider
              //     ? item.lifeAssurance_provider
              //     : "",
              // },
              hmo: {
                provider: item.hmo_provider ? item.hmo_provider : "",
                amount: 0,
              },
              pension: {
                provider: item.pension_provider ? item.pension_provider : "",
                employeePensionPin: item.pension_employeePensionPin
                  ? item.pension_employeePensionPin
                  : "",
                manually_inputted: false,
              },
              paye: {
                taxId: item.taxId ? String(item.taxId) : "N/A",
                stateForPaye: item.address ? String(item.address) : "N/A",
              },
            },
          },
        };
      });
      const data = profile.map(this.removeNullValues);
      return data;
    },

    //    createUploadArray() {
    //   const profile = this.uploadJsonData.map((item) => {

    //     return {
    //       sr: String(item.sr),
    //       profile: {
    //         phone: String(item.phone),
    //         email: item.email,
    //         firstName: item.firstName,
    //         lastName: item.lastName,
    //       },
    //       job: {
    //         jobTitle: item.jobTitle,
    //       },
    //       payment: {
    //         accountNumber: item.accountNumber,
    //         bankName: item.bankName,
    //         // accountName: item.accountName,
    //         bankCode: item.bankCode,
    //       },
    //       deductions: {
    //         lifeInsurance: {
    //           provider: item.lifeInsurance_provider
    //             ? item.lifeInsurance_provider
    //             : "",
    //         },
    //         // lifeAssurance: {
    //         //   provider: item.lifeAssurance_provider
    //         //     ? item.lifeAssurance_provider
    //         //     : "",
    //         // },
    //         hmo: {
    //           provider: item.hmo_provider ? item.hmo_provider : "",
    //         },
    //         pension: {
    //           provider: item.pension_provider ? item.pension_provider : "",
    //           employeePensionPin: item.pension_employeePensionPin
    //             ? item.pension_employeePensionPin
    //             : "",
    //         },
    //         paye: {
    //           taxId: item.taxId,
    //         },
    //       },
    //     };
    //   });
    //   return profile;
    // },

    addEmployeesWithExcelLite() {
      //Changed to hit AddSalariesAndProrate instead.
      let uploadData = [];
      uploadData = this.createUploadArray();

      this.loadingProgress = true;
      this.previewModal = false;

      this.mutate({
        endpoint: "AddSalariesAndProrate",
        service: "PAYROLL",
        data: { input: uploadData },
      })
        .then((res) => {
          this.loadingProgress = false;
          this.previewModal = true;

          if (res.salaryResult.success.length) {
            const data = res.salaryResult.success;
            let arr = [];
            if (res.salaryResult.failed.length) {
              this.toast.success(
                `${data.length} employee(s) added successfully`,
                {
                  timeout: 6000,
                }
              );
            }
            arr = data.map((p) => p.employee._id);

            // this.successfullyUploaded = arr.length;
            if (this.sendOnboardLink) {
              this.sendInvite(arr);
            }
            if (!res.salaryResult.failed.length) {
              this.previewModal = false;
              this.addSalarySuccess = true;

              this.queryEmployees();
              // this.toast.success("Salary Added Successfully");
              setTimeout(() => {
                this.$router.push({ name: "ViewEmployee" });
              }, 2000);
            }
            // window.location.reload();
          }
          if (res.salaryResult.failed.length) {
            this.errorFound = true;
            const data = res.salaryResult.failed;
            for (let message of data) {
              this.toast.error(message, { timeout: 7000 });
            }
          }

          //OLD RESPONSE HANDLER
          // if (res.success && res.data.failed === 0) {
          //   this.previewModal = false;
          //   this.addSalarySuccess = true;
          //   setTimeout(() => {
          //     this.$router.push({ name: "ViewEmployee" });
          //   }, 1000);
          // } else {
          //   this.errorFound = true;
          //   this.uploadJsonData = this.transform(res.data.failedData);
          //   this.toast.error(res.message);
          // }
        })
        .catch((e) => {
          console.log(e);
          this.loadingProgress = false;
          this.previewModal = true;
        });
    },

    uploadToServer() {
      this.addEmployeesWithExcelLite();

      // if (this.bankInvalid) {
      //   this.toast.error("Error Found in sheet");
      //   throw new Error("Correct sheet");
      // } else {
      //   this.bankInvalid = false;
      //   this.addEmployeesWithExcelLite();
      // }
    },
    transform(arr) {
      console.log("TO BE CREATED FROM", arr);
      const newArr = arr.map((obj) => {
        return {
          sr: obj._id,
          firstName: obj.profile.firstName,
          lastName: obj.profile.lastName,
          email: obj.profile.email,
          phone: obj.profile.phone,
          jobTitle: obj.job.jobTitle,
          accountNumber: obj.payment.accountNumber,
          bankCode: obj.payment.bankCode,
          reason: obj.reason,
        };
      });

      return newArr;
    },

    async doUpload(confirmed = false, template) {
      this.bankInvalid = false;
      if (template == "employee") {
        this.btnState = "disabled";
        const formData = new FormData();
        const operation = `${confirmed ? "Add" : "View"}EmployeesWithExcelLite`;
        formData.append(
          "operations",
          `{
          "query": "mutation ${operation}($file:Upload!) { ${operation}(file: $file){message data} }"
        }`
        );
        formData.append("map", `{"0": ["variables.file"]}`);
        formData.append("0", this.file, "Employees.xlsx");
        try {
          this.previewModal = false;
          // this.loadingProgress = true;
          const progress1 = useProgress().start();
          let progressValue = 0;
          const response = await axios.post(
            "https://payrollservice-d5ffb79ba43a9141.onporter.run/graphql",
            // "http://localhost:4001/graphql",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                authorization: AUTH_CONTEXT(),
                "Apollo-Require-Preflight": "true",
              },
              onUploadProgress: function (progressEvent) {
                progressValue = Math.round(
                  (progressEvent.loaded * 100) / progressEvent.total
                );

                // console.log(percent);
              },
            }
          );

          if (progressValue === 100) {
            progress1.finish();
            this.loadingProgress = false;
            this.previewModal = true;
          }
          if (confirmed === true) {
            if (response.data.data.AddEmployeesWithExcelLite.data.failedData) {
              this.uploadJsonData = [];
              this.transformObject(
                response.data.data.AddEmployeesWithExcelLite.data.failedData
              );
              this.errorFound = true;

              this.toast.error(
                `${response.data.data.AddEmployeesWithExcelLite.message}`,
                {
                  timeout: 6000,
                }
              );
            } else {
              this.previewModal = false;
              this.addSalarySuccess = true;
            }
          } else {
            if (response.data.data) {
              this.toast.info(
                `${response.data.data.ViewEmployeesWithExcelLite.message}, confirm details before uploading`,
                {
                  timeout: 6000,
                }
              );
              this.employeeSheet =
                response.data.data.ViewEmployeesWithExcelLite.data.dataFromExcel;
              if (
                response.data.data.ViewEmployeesWithExcelLite.data.errors[1]
                  .length
              ) {
                this.errorFound = true;
              }

              this.uploadJsonData = [];
              this.transformObject(
                response.data.data.ViewEmployeesWithExcelLite.data
              );
              if (this.employeeSheet.length <= 0) {
                this.toast.error(
                  "0 correct record found in Sheet. Please fill correctly."
                );
                throw new Error("0 correct record found in Sheet");
              }
              this.uploaded = true;
            }

            // this.confirmation = true;
            // this.uploadedTemplate = "employee";
          }
        } catch (err) {
          if (err) this.loadingProgress = false;
          this.btnState = "primary";
          console.log(err);
        }
        this.btnState = "primary";
      }
    },

    toggleToSalaryScreen() {
      if (!this.allowstepTwo) {
        this.toast.error("You must complete step 1");
        // this.empDetails = false;
      } else {
        this.empDetails = false;
      }
    },

    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },

    formatBytes(bytes, decimals = 2) {
      if (bytes === 0) return "0 Bytes";

      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));

      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    },

    async openPreviewModal() {
      this.fileLoading = true;
      this.loadNumber = 10;

      try {
        if (this.fileName.length === 0) {
          this.message =
            "You need to upload the populated template before proceeding";
          return;
        }

        await this.doUpload(false, "employee");
        this.loadNumber = 100;
        this.buttonLoading = true;
        // this.loadingProgress = false;

        this.previewModal = true;
      } catch (e) {
        console.log(e);
      } finally {
        this.fileLoading = false;
        this.loadingProgress = false;
      }
    },

    async previewFiles(e) {
      try {
        this.jsonData = [];
        this.uploadJsonData = [];
        this.file = null;
        let files = [];
        files = this.$refs.input.files;
        let f = files[0];

        this.file = f;
        const allowedTypes = [
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        ];

        if (!allowedTypes.includes(f.type)) {
          this.message = "File type is wrong!!";
          throw new Error(this.message);
        }
        if (f.size > 1000000) {
          this.message = "Too large, max size allowed is 1MB";
          throw new Error(this.message);
        }
        const { name, size } = f;
        this.fileName = name;
        this.fileSize = this.formatBytes(size);

        // const reader = new FileReader();
        // const data = await new Promise((resolve) => {
        //   reader.onloadend = (e) => resolve(new Uint8Array(e.target.result));
        //   reader.readAsArrayBuffer(f);
        // });

        // const workbook = XLSX.read(data, { type: "array" });
        // let sheetName = workbook.SheetNames[0];
        // let worksheet = workbook.Sheets[sheetName];
        // let jsondata = XLSX.utils.sheet_to_json(worksheet, { defval: "" });

        // const firstNameProperty = "First Name";
        // this.jsonData.push(
        //   ...jsondata.filter(
        //     (d) => d[firstNameProperty] && d[firstNameProperty].length
        //   )
        // );
      } catch (e) {
        console.log(e);
      } finally {
        this.loadingProgress = false;
      }
    },

    // previewFiles(e) {
    //   try {
    //     this.jsonData = [];
    //     this.uploadJsonData = [];
    //     this.file = null;
    //     let files = [];
    //     files = this.$refs.input.files;
    //     let f = files[0];

    //     this.file = f;
    //     const allowedTypes = [
    //       "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    //     ];

    //     if (!allowedTypes.includes(f.type)) {
    //       this.message = "File type is wrong!!";
    //       throw new Error(this.message);
    //     }
    //     if (f.size > 1000000) {
    //       this.message = "Too large, max size allowed is 1MB";
    //       throw new Error(this.message);
    //     }
    //     const { name, size } = f;
    //     this.fileName = name;
    //     this.fileSize = this.formatBytes(size);
    //     var reader = new FileReader();
    //     reader.onloadend = async (e) => {
    //       var data = new Uint8Array(e.target.result);
    //       var workbook = XLSX.read(data, { type: "array" });
    //       let sheetName = workbook.SheetNames[0];
    //       /* DO SOMETHING WITH workbook HERE */
    //       let worksheet = workbook.Sheets[sheetName];
    //       let jsondata = XLSX.utils.sheet_to_json(worksheet, { defval: "" });
    //       let root = this;

    //       // root.jsonData.push.apply(root.jsonData, jsondata);
    //       root.jsonData = root.jsonData.concat(jsondata);

    //       // jsondata.forEach(function (data) {
    //       //   root.jsonData.push(data);
    //       // });
    //       // this.jsonData = jsondata;
    //       // await this.$nextTick();
    //     };
    //     reader.readAsArrayBuffer(f);
    //   } catch (e) {
    //     console.log(e);
    //   } finally {
    //     this.loadingProgress = false;
    //   }
    // },

    async queryAllowance() {
      await this.query({
        endpoint: "ListAllowance",
        payload: this.payload2,
        service: "PAYROLL",
        storeKey: "allowance",
      });
    },
    async queryEmployees() {
      await this.query({
        endpoint: "ListEmployees",
        payload: this.payload,
        service: "EMP",
        storeKey: "listEmployees",
      });
    },

    getEmployeeById(id) {
      console.log(id);
      const employees = this.allEmployees.data;

      let employeeDetails = null;
      employees.forEach(function (employee, index) {
        if (employee._id === id) {
          console.log("GOT Here", employee);
          employeeDetails = employee;
        }
      });

      return employeeDetails;
    },
    updateBank() {
      this.mutate({
        endpoint: "UpdateEmployeePayment",
        service: "EMP",
        data: { id: this.inviteArg.employeeId, payment: this.bankArgs },
      })
        .then((res) => {
          if (res.success) {
            this.toast.success("Bank Record Updated Successfully");
          }
        })
        .catch((e) => console.log(e));
    },
    verifyAccountName() {
      this.loadingBank = true;
      let endpointData = {
        accountNumber: this.args.accountNumber,
        bankCode: this.args.bankCode,
      };
      this.mutate({
        endpoint: "VerifyAccountDetails",
        data: { input: endpointData },
        service: "EMP",
      })
        .then((res) => {
          console.log(res);
          if (res.success === true) {
            this.loadingBank = false;
            this.args.accountName = res.data.data.account_name;
            this.args.accountName = this.args.accountName.toLowerCase();
            // this.updateBank();
            // this.verify = false;
            const first = this.args.firstName.toLowerCase().trim();
            const second = this.args.accountName.toLowerCase();
            const third = this.args.lastName.toLowerCase().trim();

            const newArray = second.split(" ");
            const holder = [];
            for (let letter of newArray) {
              if (first.includes(letter) || third.includes(letter)) {
                holder.push("true");
              } else {
                holder.push("false");
              }
            }
            if (!holder.includes("true")) {
              this.accountWarning =
                "Bank name does not tally with employee name";
            }
            this.toast.success("Account name verified.");
          } else if (!res.success) {
            this.args.accountNumber = "";
            this.loadingBank = false;
            // this.verify = false;
          }
        })
        .catch((e) => {
          console.log(e);
          this.toast.error(e.message);
          this.loadingBank = false;
        });
    },

    validateAllowanceThenNext() {
      console.log(this.args.staffLevel, "BEFORE VALIDATE");
      this.args.staffLevel.allowanceDetails = []; //empty the array first
      if (this.args.staffLevel.usePercentageForAllowance) {
        let total = 0;

        for (let field of Object.keys(this.allowanceData)) {
          total += Number(this.allowanceData[field]);
        }
        this.totalAllowanceValue = total;
        // if (total != 100 && total != 0) {
        //   this.toast.error(
        //     "Allowances Percentages must sum up to 100% of Total Taxable Salary"
        //   );
        //   return false;

        // }
        if (total == 0) {
          //Logic to distribute allowances at 50,30,20
          let temp = "";
          let temp2 = "";
          let temp3 = "";
          for (let field of this.allAllowanceData.data) {
            if (field.name.toLowerCase() == "basic") {
              temp = field._id;
            }
            if (field.name.toLowerCase() == "housing") {
              temp2 = field._id;
            }
            if (field.name.toLowerCase() == "transport") {
              temp3 = field._id;
            }
          }
          this.args.staffLevel.allowanceDetails.push(
            {
              allowanceId: temp,
              percentage: 50,
            },
            {
              allowanceId: temp2,
              percentage: 30,
            },
            {
              allowanceId: temp3,
              percentage: 20,
            }
          );
        }
      } else {
        let total = 0;

        for (let field of Object.keys(this.allowanceData)) {
          total += Number(this.allowanceData[field]);
          console.log(this.allowanceData, total, "CheckTOtal");
        }
        this.totalAllowanceValue = total;

        // if (total !== Number(this.args.staffLevel.grossAmount) && total != 0) {
        //   this.toast.error("Total Allowances must equal Total Taxable Salary");
        //   return false;
        // }
        if (total === 0) {
          let temp = "";
          for (let field of this.allAllowanceData.data) {
            if (field.name == "basic") {
              temp = field._id;
            }
          }
          this.args.staffLevel.allowanceDetails.push({
            allowanceId: temp,
            amount: Number(this.args.staffLevel.grossAmount),
          });
        }
      }
      // this.bonus = true;
      // this.allowance = false;
    },

    processNumber(phoneNumber) {
      if (phoneNumber) {
        let phone = phoneNumber;
        let firstDigit = phone.charAt(0);
        if (firstDigit == "0") {
          let formatted = phone.replace("0", "234").replace(/\s+/g, "");
          return formatted;
        } else if (firstDigit == 2) {
          let formatted = phone.replace(/\s+/g, "");
          return formatted;
        } else {
          let formatted = phone.replace(/\s+/g, "");
          return `234${formatted}`;
        }
      } else {
        return "";
      }
    },

    getNumOfDays(start, end) {
      const startDate = new Date(start);
      const endDate = new Date(end);

      // Calculate the time difference in milliseconds
      const timeDiff = endDate - startDate;

      // Convert milliseconds to days
      const daysDiff = timeDiff / (1000 * 60 * 60 * 24);
      return daysDiff;
    },
    prorateSalary() {
      let { startDate, endDate } = this.dates;
      const dateArr = startDate.split("-");
      const start = Number(startDate.slice(8));
      const end = Number(endDate.slice(8));
      const month = Number(startDate.slice(5, 7)) - 1;
      const year = Number(startDate.slice(0, 4));
      // const days = Math.abs(start - end);
      const days = this.getNumOfDays(startDate, endDate);

      this.prorateArg.month = month;
      this.prorateArg.year = year;
      this.prorateArg.days = days;
      const input = {
        month,
        days,
        year,
        holidays: this.prorateArg.holidays,
        holidays: this.prorateArg.holidays,
        weekendDay: this.prorateArg.weekendDay,
        netAmount: this.args.staffLevel.grossAmount,
      };

      const net = this.prorateNet(input);
      this.proratedSalary = this.truncateAmount(net);
      this.prorated = true;
    },
    async createAllowance() {
      if (this.allowanceArg.name.length) {
        this.loading.add = true;
        try {
          let res = await this.mutate({
            endpoint: "CreateAllowance",
            data: { input: this.allowanceArg },
            service: "PAYROLL",
          });
          console.log(res);
          if (res.success) {
            this.addAllowance = false;
            this.allowanceArg.name = "";
            // this.transformAllowances();
            await this.queryAllowance();
            this.toast.success("Allowance Created Successfuly");
          } else {
            this.toast.error(res.error[0].message);
          }
        } catch (e) {
          console.log(e);
          this.toast.error("This allowance already exists");
        } finally {
          this.loading.add = false;
        }
      } else if (this.selectedAllowances.length) {
        this.toggleAllowance(this.selectedAllowances);
        this.addAllowance = false;
      }
    },

    sendLink(e) {
      console.log(e);
      this.sendOnboardLink = !this.sendOnboardLink;
    },

    submit() {
      if (this.validatePhone() && this.validateEmail()) {
        if (this.args.employmentType.length === 0) {
          this.toast.error("Employment type is required");
          throw new Error("Employment Type is required");
        }
        // if (this.args.email.length == 0) {
        //   this.toast.info(
        //     "It is recommended that you fill in employee email address"
        //   );
        // }
        // if (this.args.phoneNumber.length == 0) {
        //   this.toast.info(
        //     "It is recommended that you fill in employee phone number"
        //   );
        // }
        this.allowstepTwo = true;
        this.empDetails = false;
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    },
    transformAllowances() {
      console.log("GOT TRANSFORMED");
      this.holdAllowanceDetails = [];
      // this.args.staffLevel.allowanceDetails = [];
      console.log(this.allowanceData.length, "LEON");
      if (this.totalAllowanceValue !== 0) {
        for (var item in this.allowanceData) {
          if (!this.args.staffLevel.usePercentageForAllowance) {
            this.holdAllowanceDetails.push({
              allowanceId: item,
              amount: Number(this.allowanceData[item]),
            });
          } else {
            this.holdAllowanceDetails.push({
              allowanceId: item,
              percentage: Number(this.allowanceData[item]),
            });
          }
        }
        this.args.staffLevel.allowanceDetails = this.holdAllowanceDetails;
      }
    },
    getBenKey(k) {
      const obj = {
        PAYE: "paye",
        Pension: "pension",
        NHF: "nhf",
        NSITF: "nsitf",
        ITF: "itf",
        WHT: "wht",
        Group_Life_Insurance: "lifeInsurance",
        Employee_Life_Assurance: "lifeAssurance",
        HMO: "hmo",
        Business_Expense: "businessExpense",
        Gratuity: "gratuity",
      };
      return obj[k];
    },
    areAllPropertiesDefined(obj) {
      const keys = Object.keys(obj);
      const exemp = ["providerPin", "taxId", "paymentTypes"];
      for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        if (!exemp.includes(key)) {
          if (obj[key] === undefined || obj[key] === null || obj[key] === "") {
            return false;
          }
        }
      }
      return true;
    },
    reviver(key, value) {
      const exc = [
        "phoneNumber",
        "accountNumber",
        "bankCode",
        "userName",
        "taxId",
        "providerPin",
        "employeePensionPin",
      ];
      // Check if the value is a string that represents a number
      if (
        !exc.includes(key) &&
        typeof value === "string" &&
        /^\d+(\.\d+)?$/.test(value)
      ) {
        // Convert the string to a number
        return Number(value);
      }
      // Return the original value
      return value;
    },
    matchStatutoryDeds(item) {
      const obj = {
        paye: "PAYE",
        pension: "Pension",
        nhf: "NHF",
        nsitf: "NSITF",
        itf: "ITF",
        wht: "WHT",
        lifeInsurance: "Life Insurance",
        lifeAssurance: "Life Assurance",
        hmo: "HMO",
        businessExpense: "Business Expense",
        gratuity: "Gratuity",
      };

      return obj[item];
    },
    processArgs() {
      if (this.args) {
        this.args.staffLevel.withholdingTax = false;
        const index = this.args.staffLevel.benefits.indexOf("WHT");
        if (index > -1) {
          this.args.staffLevel.withholdingTax = true;
        }
        this.args.phoneNumber = this.processNumber(this.args.phoneNumber);
        // this.args.staffLevel.grossAmount = Number(
        //   this.args.staffLevel.grossAmount
        // );

        // if (this.args.staffLevel.hmo) {
        //   this.args.staffLevel.hmo.amount = Number(
        //     this.args.staffLevel.hmo.amount
        //   );
        // }
        // if (this.args.staffLevel.lifeInsurance) {
        //   this.args.staffLevel.lifeInsurance.amount = Number(
        //     this.args.staffLevel.lifeInsurance.amount
        //   );
        // }

        // if (this.args.staffLevel.lifeAssurance) {
        //   this.args.staffLevel.lifeAssurance.amount = Number(
        //     this.args.staffLevel.lifeAssurance.amount
        //   );
        // }
        // if (this.args.staffLevel.wht) {
        //   this.args.staffLevel.wht.amount = Number(
        //     this.args.staffLevel.wht.amount
        //   );
        //   this.args.staffLevel.wht.percentage = Number(
        //     this.args.staffLevel.wht.percentage
        //   );
        // }

        // if (this.args.staffLevel.itf) {
        //   this.args.staffLevel.itf.amount = Number(
        //     this.args.staffLevel.itf.amount
        //   );
        // }

        // if (this.args.staffLevel.nsitf) {
        //   this.args.staffLevel.nsitf.amount = Number(
        //     this.args.staffLevel.nsitf.amount
        //   );
        // }

        // if (this.args.staffLevel.pension) {
        //   this.args.staffLevel.pension.amount = Number(
        //     this.args.staffLevel.pension.amount
        //   );
        //   this.args.staffLevel.pension.employerPensionContribution = Number(
        //     this.args.staffLevel.pension.employerPensionContribution
        //   );
        //   this.args.staffLevel.pension.employeePensionContribution = Number(
        //     this.args.staffLevel.pension.employeePensionContribution
        //   );
        // }

        // if (this.args.staffLevel.paye) {
        //   this.args.staffLevel.paye.amount = Number(
        //     this.args.staffLevel.paye.amount
        //   );
        // }

        // if (this.args.staffLevel.nhf) {
        //   this.args.staffLevel.nhf.amount = Number(
        //     this.args.staffLevel.nhf.amount
        //   );
        // }
        // if (this.args.staffLevel.gratuity) {
        //   this.args.staffLevel.gratuity.amount = Number(
        //     this.args.staffLevel.gratuity.amount
        //   );
        //   this.args.staffLevel.gratuity.salaryAmount = Number(
        //     this.args.staffLevel.gratuity.salaryAmount
        //   );
        //   this.args.staffLevel.gratuity.yearsWorked = Number(
        //     this.args.staffLevel.gratuity.yearsWorked
        //   );
        // }

        // if (this.args.staffLevel.businessExpense) {
        //   this.args.staffLevel.businessExpense.amount = Number(
        //     this.args.staffLevel.businessExpense.amount
        //   );
        // }
        const arr = [
          // "paye",
          "pension",
          "hmo",
          "lifeInsurance",
          "lifeAssurance",
          // "nsitf",
          // "itf",
          // "nhf",
          "wht",
          "gratuity",
          "businessExpense",
        ];
        console.log("CHECK TEMP", this.tempBen);

        if (this.tempBen.length) {
          for (let ben of this.tempBen) {
            if (
              !this.areAllPropertiesDefined(
                // this.args.staffLevel[this.getBenKey(ben)]
                this.args.staffLevel[ben]
              )
            ) {
              console.log(ben, "CAUGHT");
              // errorRules.staffLevel.benefits =
              //   "Please fill in the statutory deduction details below.";
              this.toast.error(
                `Fill in details for ${this.matchStatutoryDeds(ben)}`
              );
              this.validate = true;
              throw new Error("Fill in all details");
              // break;
            }
          }
        }

        // const newArr = arr.map((item) => {
        //   if (!this.tempBen.includes(item)) {
        //     console.log(item, "N/A");
        //     delete this.args.staffLevel[item];
        //     return this.args.staffLevel;
        //   } else {
        //     if (
        //       this.args.staffLevel[item] &&
        //       this.args.staffLevel[item].amount === 0
        //     ) {
        //       console.log(this.args.staffLevel[item], item, "CAUGHT");
        //       this.toast.error(
        //         "Please fill in the details of other selected deduction before continuing"
        //       );
        //       this.validate = true;
        //       throw new Error("Fill in all details");
        //     }
        //   }
        // });
        const removeObj = [
          "nsitf",
          "itf",
          "nhf",
          "paye",
          "pension",
          "hmo",
          "lifeInsurance",
          "lifeAssurance",
          "wht",
          "gratuity",
          "businessExpense",
        ];

        const newObj = removeObj.map((ro) => {
          if (!this.tempBen.includes(ro)) {
            this.args.staffLevel[ro] = null;
            return this.args.staffLevel;
          }
        });

        const benArr = [
          "PAYE",
          "Pension",
          "NHF",
          "NSITF",
          "ITF",
          "Group_Life_Insurance",
          "Employee_Life_Assurance",
          "HMO",
        ];
        this.args.staffLevel.benefits = this.tempBen.map((item) => {
          if (item === "paye") return "PAYE";
          if (item === "pension") return "Pension";
          if (item === "nhf") return "NHF";
          if (item === "nsitf") return "NSITF";
          if (item === "itf") return "ITF";
          if (item === "wht") return "WHT";
          if (item === "lifeInsurance") return "Group_Life_Insurance";
          if (item === "lifeAssurance") return "Employee_Life_Assurance";
          if (item === "hmo") return "HMO";
          if (item === "businessExpense") return "Business_Expense";
          if (item === "gratuity") return "Gratuity";
        });
        console.log(this.args.staffLevel.benefits);

        return true;
      }
      return false;
    },

    async allowanceComplete(final) {
      // if (this.salaryArgsFromStore.length === 0) {
      //   this.addMore(this.args, this.prorateArg);
      // }

      // return true;

      try {
        this.errorCaught = false;
        this.loading.add = true;
        if (final) {
          const check = this.addMore(this.args, this.prorateArg);
          if (check == false) {
            throw new Error("Bad user input");
          }
        }

        const payloadData = JSON.parse(
          JSON.stringify(this.salaryArgsFromStore),
          this.reviver
        );
        const arr = [payloadData[payloadData.length - 1]];
        let res = await this.mutate({
          endpoint: "AddSalariesAndProrate",
          data: {
            input: arr,
          },
          service: "PAYROLL",
        });

        // this.store.$patch({
        //   salaryArray: [],
        // });
        if (res.salaryResult.success.length) {
          console.log(res);
          const data = res.salaryResult.success;
          let arr = [];
          for (let person of data) {
            // this.toast.success(
            //   `${person.employee.profile.firstName} ${person.employee.profile.lastName} added successfully`,
            //   {
            //     timeout: 6000,
            //   }
            // );
            arr.push(person.employee._id);
            this.successfullyUploaded.push(person.employee._id);
          }
          if (this.sendOnboardLink) {
            this.sendInvite(arr);
          }
          if (final === true) {
            this.store.$patch({
              salaryArray: [],
            });
            this.store.$patch((state) => {
              state.successfullyAdded = [];
            });
            this.addSalarySuccess = true;
            setTimeout(() => {
              this.$router.push({ name: "ViewEmployee" });
            }, 2000);
          } else {
            this.allPhoneNumbers.push(this.args.phoneNumber);
            this.store.$patch((state) => {
              state.successfullyAdded.push(arr[arr.length - 1]);
            });
          }
          // await this.queryEmployees();
          this.loading.add = false;
          // this.toast.success("Salary Added Successfully");

          // window.location.reload();
        } else {
          const data = res.salaryResult.failed;
          for (let message of data) {
            this.toast.error(message, { timeout: 7000 });
          }
          this.errorCaught = true;
          this.loading.add = false;
        }

        if (res.prorateResult.failed.length === 0) {
          const data = res.prorateResult.success;
          for (let person of data) {
            this.toast.success(
              `${person.employee.profile.firstName} ${person.employee.profile.lastName}'s salary prorated successfully`,
              {
                timeout: 6000,
              }
            );
            // window.location.reload();
          }
        } else {
          this.errorCaught = true;
          this.loading.add = false;
          // if (this.errorCaught) {
          //   this.store.$patch({
          //     salaryArray: [],
          //   });
          // }
          const data = res.prorateResult.failed;
          for (let message of data) {
            this.toast.error(message, { timeout: 7000 });
          }
          // this.resetObj(this.prorateArg, "prorateArg");
          // this.resetObj(this.args, "args");
          // this.clearObj = true;
          // this.args.staffLevel.benefits = [];
          // this.args.staffLevel.allowanceDetails = [];
          // this.bankName = "";
          // this.allowanceData = [];
          // this.empDetails = true;
          // this.store.$patch({
          //   salaryArray: [],
          // });
          // window.location.reload();
        }
      } catch (e) {
        console.log(e, "CAUGHT");
        this.errorCaught = true;
        this.loading.add = false;
        // if (this.errorCaught) {
        //   this.store.$patch({
        //     salaryArray: [],
        //   });
        // }
        // this.resetObj(this.prorateArg, "prorateArg");
        // this.resetObj(this.args, "args");
        // this.clearObj = true;
        // this.args.staffLevel.benefits = [];
        // this.args.staffLevel.allowanceDetails = [];
        // this.bankName = "";
        // this.allowanceData = [];
        // this.empDetails = true;
        // this.store.$patch({
        //   salaryArray: [],
        // });
        console.log(e);
      }
    },
    toggleAdd() {
      this.singleAdd = !this.singleAdd;
    },
    processDate() {
      let today = new Date();
      let dd = String(today.getDate()).padStart(2, "0");
      let mm = String(today.getMonth() + 1).padStart(2, "0");
      let yyyy = today.getFullYear();
      today = yyyy + "-" + mm + "-" + dd;
      this.today = today;
    },
    checkIfUserNameExists(name) {
      const usernames =
        this.allEmployees && this.allEmployees.data.length
          ? this.allEmployees.data
              .map((emp) => emp.job.userName)
              .filter((e) => e != null && e != undefined)
          : [];

      return usernames.includes(name);
    },
    generateRandomNumber() {
      const currentTime = new Date().getTime();
      const minLength = 4;
      const maxLength = 6;

      // Generate a random length between minLength and maxLength
      const randomLength =
        Math.floor(Math.random() * (maxLength - minLength + 1)) + minLength;

      // Use the last n digits of the current time as a random number, where n is the random length
      const randomNLengthNumber = currentTime % Math.pow(10, randomLength);
      return randomNLengthNumber;
    },
  },

  mounted() {
    this.generateUserName();
  },
  unmounted() {
    // console.log("UNMOUNTED");
    // this.store.$patch({
    //   salaryArray: [],
    // });
    // this.store.$patch((state) => {
    //   state.salaryArray = [];
    //   state.tempStoreBen = [];
    //   state.tempAllowanceData = [];
    // });
  },

  async created() {
    await this.queryAllowance();
    await this.queryEmployees();
    this.processDate();
    if (
      this.allAllowanceData &&
      this.allAllowanceData.data &&
      this.allAllowanceData.data.length
    ) {
      for (let all of this.allAllowanceData.data) {
        if (!this.staticAllowances.includes(all.name)) {
          this.hideAllowance(all._id);
        }
      }
    }

    for (let i = 1; i <= 31; i++) {
      this.holidaysArray.push({
        label: i < 10 ? `0${i}` : `${i}`,
        value: i,
      });
    }

    this.allPhoneNumbers =
      this.allEmployees && this.allEmployees.data.length
        ? this.allEmployees.data
            .map((emp) => emp.profile.phone)
            .filter((e) => e != null && e != undefined)
        : [];

    this.allEmails =
      this.allEmployees && this.allEmployees.data.length
        ? this.allEmployees.data
            .map((emp) => emp.profile.email)
            .filter((e) => e != null && e != undefined)
        : [];

    // this.store.$patch({
    //   salaryArray: [],
    // });
    // console.log(this.salaryArgsFromStore);
  },
};
</script>

<style></style>
